import { demandAction, fetchActivityLog, fetchDemandComments } from "../../../api/demand/demand.service"
import { ADD_DEMAND_ACTION, ADD_DEMAND_COMMENT, FETCH_ACTIVITY_LOGS } from "../actionTypes"

const request = () => ({ type: ADD_DEMAND_ACTION.REQUEST })
const failure = (error) => ({ type: ADD_DEMAND_ACTION.FAILURE, error })
const success = () => ({ type: ADD_DEMAND_ACTION.SUCCESS })

export const addDemandAction = (payload,id) => {
  return (dispatch, getState) => {
    dispatch(request());
    return demandAction(payload,id)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      })
  }
}

const commentRequest = () => ({ type: ADD_DEMAND_COMMENT.REQUEST })
const commentfailure = (error) => ({ type: ADD_DEMAND_COMMENT.FAILURE, error })
const commentSuccess = (obj)=>({type: ADD_DEMAND_COMMENT.SUCCESS, obj})

export const getDemandComments = (requestId,next=null)=>{
    return (dispatch, getState)=>{        
        dispatch(commentRequest())
        return fetchDemandComments(requestId,next)
        .then(response => { 
            let obj={
                "data":response?.comments,
                "next":response?.next,
                "isLoadMore": next?true:false
            }
            dispatch(commentSuccess(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(commentfailure(error?.message))
            return Promise.resolve(false)
        })
    }
}


const requestlog = () => ({ type: FETCH_ACTIVITY_LOGS.REQUEST });
const failurelog = (error) => ({ type: FETCH_ACTIVITY_LOGS.FAILURE,error });
const successlog = (data) => ({ type: FETCH_ACTIVITY_LOGS.SUCCESS,data});

export const getActivityLog = (id) => {
  return (dispatch, getState) => {
    dispatch(requestlog());
    return fetchActivityLog(id)
      .then((res) => {
        dispatch(successlog(res));
        return Promise.resolve(true);

      })
      .catch((error) => {
        dispatch(failurelog(error?.message));
        return Promise.resolve(false);
      });
  };
};
